import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { useCallback } from "react";
import { getPartnerCode } from "app/reducers/partnerSelector";
import { useMyBookingsCustomerRequestsCount } from "app/features/myBookings";
import {
	getAvailableCreditNotesTotal,
	getAvailableCreditsTotal,
	hasAnyCreditNotes,
} from "app/pages/Account/MyCoupons/couponSelector";
import { logout as logoutAction } from "app/pages/Auth/AuthActions";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import { isWhiteLabel } from "app/reducers/brandSelector";
import AccountMenuAuthenticated from "app/pages/Header/AccountMenu/AccountMenuAuthenticated/AccountMenuAuthenticated";
import { isIdentified } from "app/pages/Auth/authSelectors";

const mapStateToProps = state => {
	return {
		brand: state.brand,
		enableSponsorship: state.partner.enableSponsorship,
		partnerCode: getPartnerCode(state),
		isWhiteLabel: isWhiteLabel(state),
		enableCredits: state.partner.enableCredits,
		shouldDisplayCreditNotesEntry: hasAnyCreditNotes(state),
		creditsAmount: getAvailableCreditsTotal(state),
		creditNotesAmount: getAvailableCreditNotesTotal(state),
		isIdentified: isIdentified(state),
	};
};

const AccountMenuAuthenticatedContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	const showCustomerRequestNotification = useMyBookingsCustomerRequestsCount() > 0;
	const dispatch = useDispatch();
	const { track } = useAnalytics();
	const logout = useCallback(() => dispatch(logoutAction({ track })), [dispatch, track]);
	return (
		<AccountMenuAuthenticated
			{...props}
			{...stateProps}
			logout={logout}
			showCustomerRequestNotification={showCustomerRequestNotification}
		/>
	);
};

export default AccountMenuAuthenticatedContainer;
